//
// Module for the Participant Counseling Appointments Edit view
//
rs.module("content/participant/account/counselingappointments/edit",

    [
        "common/select-helper",
        "common/visibility",
        "ui/framework/client-templates"
    ],

    function (selectHelper, visibility, clientTemplates) {

        // Initialize the module
        function initialize(
            jsSelectors,
            confirmationModes,
            codeValues,
            distributionMethods,
            backendUrls,
            preferedEmail,
            availableCounselors,
            isEdit,
            calendarIntegrationEnabled,
            isTestMode,
            roomsDisableList,
            resourcesDisableList,
            scheduleErrorTemplateKey) {

            // Unpack Js Selectors
            var form = $.js(jsSelectors.form);
            var confirmationModeSelect = form.js(jsSelectors.confirmationMode);
            var optionalLetterText = form.js(jsSelectors.optionalLetterText);
            var reviewComment = form.js(jsSelectors.reviewComment);
            var distributionMethodSelect = form.js(jsSelectors.distributionMethod);
            var distributionMethodSelectHelper = selectHelper.getHelper(distributionMethodSelect);
            var printerIdSelect = form.js(jsSelectors.printerId);
            var printerIdSelectHelper = selectHelper.getHelper(printerIdSelect);
            var printerContainer = form.js(jsSelectors.printerContainer);
            var emailContainer = form.js(jsSelectors.emailContainer);
            var emailAddress = form.js(jsSelectors.emailAddress);
            var defaultEmailAddress = form.js(jsSelectors.defaultEmailAddress);
            var locationSelect = form.js(jsSelectors.locationSelect);            
            var address = form.js(jsSelectors.address);
            var virtualUrlRow = form.js(jsSelectors.virtualUrlRow);
            var virtualUrl = form.js(jsSelectors.virtualUrl);
            var virtualUrlLink = form.js(jsSelectors.virtualUrlLink);

            var counselorSelect = form.js(jsSelectors.counselorSelect);
            var appointmentStatusSelect = form.js(jsSelectors.appointmentStatusSelect);            
            var startDateTimePicker = form.js(jsSelectors.startDateTimePicker);
            var durationPicker = form.js(jsSelectors.durationPicker);

            var selectedDateLabel = form.js(jsSelectors.selectedDateLabel);
            var previousDayLink = form.js(jsSelectors.previousDayLink);
            var nextDayLink = form.js(jsSelectors.nextDayLink);
            var counselorSchedule = form.js(jsSelectors.counselorSchedule);
            var scheduleHolder = form.js(jsSelectors.scheduleHolder);
            var scheduleScrollPosition = form.js(jsSelectors.scheduleScrollPosition);
            var scheduleLoadingTemplate = form.js(jsSelectors.scheduleLoadingTemplate);
            var outlookApptsHelpText = form.js(jsSelectors.outlookApptsHelpText);
            var pgApptsHelpText = form.js(jsSelectors.pgApptsHelpText);

            var appointmentSection = form.js(jsSelectors.appointmentSection);
            var appointmentCheckbox = form.js(jsSelectors.appointmentCheckbox);
            var roomSelect = form.js(jsSelectors.roomSelect);
            var resourcesSelect = form.js(jsSelectors.resourcesSelect);
            var roomsAndResourcesSpinners = form.js(jsSelectors.roomsAndResourcesSpinners, { multiple: true });
            var additionalAttendess = form.js(jsSelectors.additionalAttendess);
            var privateCheckbox = form.js(jsSelectors.privateCheckbox);
            var counselorCalendarEmail = form.js(jsSelectors.counselorCalendarEmail);

            // Build "dictionary" mappping counselor keys to calendar email addresses
            var counselorCalendarEmails = {};
            availableCounselors.forEach(function(item, index) {
                counselorCalendarEmails[item.counselorKey] = item.calendarEmailAddress;
            });

            resetDefaultDistributionValues();

            confirmationModeSelect.on("change", function () {
                var doNotDistributeSelected = parseInt(confirmationModeSelect.val()) === confirmationModes.doNotDistribute;
                var saveForReviewSelected = parseInt(confirmationModeSelect.val()) === confirmationModes.saveForReview;
                var distributeSelected = parseInt(confirmationModeSelect.val()) === confirmationModes.distribute;

                if (doNotDistributeSelected || saveForReviewSelected) {
                    visibility.hide(printerContainer);
                    visibility.hide(emailContainer);
                    distributionMethodSelectHelper.setValue(null);
                    printerIdSelectHelper.setValue(null);
                    emailContainer.find("input,textarea").each(function () {
                        $(this).val(null);
                    });
                }
                distributionMethodSelectHelper.setDisabled(doNotDistributeSelected || saveForReviewSelected);
                optionalLetterText.prop("disabled", doNotDistributeSelected);
                reviewComment.prop("disabled", doNotDistributeSelected || distributeSelected);
                if (distributeSelected) {
                    onDistributionMethodChanged();
                    distributionMethodSelectHelper.selectIndex(0);
                }
            });

            distributionMethodSelect.on("change", onDistributionMethodChanged);

            function onDistributionMethodChanged() {
                var isEmail = parseInt(distributionMethodSelect.val()) == distributionMethods.emailDefault || parseInt(distributionMethodSelect.val()) == distributionMethods.email;
                var isPrint = parseInt(distributionMethodSelect.val()) == distributionMethods.printDefault || parseInt(distributionMethodSelect.val()) == distributionMethods.print;
                visibility.setVisible(printerContainer, isPrint);
                visibility.setVisible(emailContainer, isEmail);

                resetDefaultDistributionValues();
                if (!(isEmail && distributionMethodSelect.find(':selected')[0].text.includes("Default"))) {
                    emailAddress.val(null);
                    emailAddress.prop("disabled", false);
                    defaultEmailAddress.val(null);
                    defaultEmailAddress.prop("disabled", true);
                }
            }

            function resetDefaultDistributionValues() {
                var isEmail = parseInt(distributionMethodSelect.val()) == distributionMethods.emailDefault || parseInt(distributionMethodSelect.val()) == distributionMethods.email;
                if (isEmail && distributionMethodSelect.find(':selected')[0].text.includes("Default")) {
                    emailAddress.val(preferedEmail);
                    emailAddress.prop("disabled", true);
                    defaultEmailAddress.val(preferedEmail);
                    defaultEmailAddress.prop("disabled", false);
                }
            }

            locationSelect.on("change", function () {
                if (locationSelect.val() == 0 && locationSelect.val() != "") {
                    visibility.show(virtualUrlRow);
                    visibility.hide(address);
                    showUrlIfValid();
                }
                else {
                    visibility.hide(virtualUrlRow);
                    visibility.show(address);
                    visibility.hide(virtualUrlLink);
                }

                $.getJSON(backendUrls.getLocation,
                    { locationKey: locationSelect.val() }
                )
                .done(function (data) {
                    address[0].innerHTML = "";
                    if (data.address1) {
                        address[0].innerHTML += data.address1;
                    }
                    if (data.address2) {
                        address[0].innerHTML += "<br/>" + data.address2;
                    }
                    if (data.city) {
                        address[0].innerHTML += "<br/>" + data.city;
                    }
                    if (data.country == codeValues.usaName && data.state) {
                        address[0].innerHTML += ", " + data.state;
                    }
                    if (data.zipCode) {
                        address[0].innerHTML += " " + data.zipCode
                    }
                });
            });

            virtualUrl.on("input", showUrlIfValid);
            showUrlIfValid();
            // set visibility of virtualUrlLink if virtualUrl.val() is a valid url
            function showUrlIfValid() {
                try {
                    var link = new URL(virtualUrl.val());
                    virtualUrlLink[0].innerHTML = "<a class='input-group-text form-control-sm' href='" + link.href + "' target='_blank'>Join</a>";
                    if (appointmentStatusSelect.val() != codeValues.cancelled) {
                        visibility.show(virtualUrlLink);
                    }
                }
                catch {
                    virtualUrlLink[0].innerHTML = null;
                    visibility.hide(virtualUrlLink);
                }
            }

            // Hook up event listeners for schedule and calendar appointments if this is an add
            if (!isEdit) {

                // Scroll the schedule to the position it was before a postback
                if (scheduleScrollPosition.val()) {
                    scheduleHolder.scrollTop(scheduleScrollPosition.val());
                }

                // If there was an error, we need to re-disable unavailable rooms and resources after a post back
                if (roomsDisableList && resourcesDisableList) {
                    selectHelper.getHelper(roomSelect).disableOptions(roomsDisableList);
                    selectHelper.getHelper(resourcesSelect).disableOptions(resourcesDisableList);
                }

                // Hook up scroll evet to save off the scroll position so that we can scroll to it after a post back
                scheduleHolder.scroll(_.debounce(function () { scheduleScrollPosition.val(scheduleHolder.scrollTop()); }, 200));

                // Hook up counselor change events for loading counselor schedule
                counselorSelect.change(function () {

                    // hide the schedule help text right away if we are switching counselors (one will be re shown after loading the schedule)
                    outlookApptsHelpText.hide();
                    pgApptsHelpText.hide();

                    counselorCalendarEmail.val(counselorCalendarEmails[$(this).val()]);
                    _displayCounselorSchedule(true);
                });

                // Hook up start date time change event for loading counselor schedule
                startDateTimePicker.change(_.debounce(function () {

                    var reloadSchedule = true;

                    var dateTimeNow = _dateToUTC(new Date());
                    var newDateTime = _dateToUTC(startDateTimePicker.val());

                    // Check to see if the date changed or if it was just the time
                    // If the year, month and date match then we don't need to reload the schedule
                    if ($(this).data("previous-date")) {

                        var oldDateTime = _dateToUTC($(this).data("previous-date"));

                        reloadSchedule =
                            oldDateTime.getFullYear() != newDateTime.getFullYear() ||
                            oldDateTime.getMonth() != newDateTime.getMonth() ||
                            oldDateTime.getDate() != newDateTime.getDate();

                        // If the new selected date goes from in the past to in the future, check the appointment checkbox
                        if (oldDateTime.getTime() < dateTimeNow.getTime() && newDateTime.getTime() >= dateTimeNow.getTime()) {
                            appointmentCheckbox.setChecked();
                        }
                        else if (oldDateTime.getTime() >= dateTimeNow.getTime() && newDateTime.getTime() < dateTimeNow.getTime()) {
                            // If the new selected date goes from in the future to in the past, uncheck the appointment checkbox
                            appointmentCheckbox.setChecked(false)
                        }
                    }
                    else {
                        appointmentCheckbox.setChecked(newDateTime.getTime() >= dateTimeNow.getTime())
                    }

                    // update previous-date with the newly selected date
                    $(this).data("previous-date", newDateTime);

                    // Only reload the schedule if we get a valid date. This is to reduce the schedule flashing as users are typing dates
                    if ($(this).val()) {
                        _displayCounselorSchedule(reloadSchedule);
                    }
                }, 500));

                // Hook up click events for next/previous day links
                previousDayLink.click(function () { _incrementStartDateTime(-1); });
                nextDayLink.click(function () { _incrementStartDateTime(1); });

                // hook up create appointment check changed event
                appointmentCheckbox.change(function () {
                    var checked = $(this).is(":checked");

                    if (!checked) {
                        selectHelper.getHelper(roomSelect).setValue(null);
                        selectHelper.getHelper(resourcesSelect).setValue(null);
                        additionalAttendess.val(null);
                        privateCheckbox.setChecked(false);
                    }
                    
                    selectHelper.getHelper(roomSelect).setDisabled(!checked);
                    selectHelper.getHelper(resourcesSelect).setDisabled(!checked);
                    additionalAttendess.prop("disabled", !checked || isTestMode);
                    privateCheckbox.prop("disabled", !checked);
                });
            }

            //
            // Helper method to increment the appointment start date
            //
            function _incrementStartDateTime(dayIncrement) {

                var startDateTime = new Date(startDateTimePicker.val());

                var newStartDateTime = new Date(
                    Date.UTC(
                        startDateTime.getFullYear(),
                        startDateTime.getMonth(),
                        startDateTime.getDate() + dayIncrement,
                        startDateTime.getHours(),
                        startDateTime.getMinutes()
                    )
                );

                var isoString = newStartDateTime.toISOString();
                startDateTimePicker.val(isoString.substring(0, isoString.length - 1));

                startDateTimePicker.change();
            }

            //
            // Helper method to convert a date to UTC
            //
            function _dateToUTC(date) {

                var dateObject = new Date(date);

                return new Date(
                    Date.UTC(
                        dateObject.getUTCFullYear(),
                        dateObject.getUTCMonth(),
                        dateObject.getUTCDate(),
                        dateObject.getUTCHours(),
                        dateObject.getUTCMinutes()));
            }

            //
            // Helper method to load the counselor's schedule
            //
            function _displayCounselorSchedule(reloadSchedule) {

                // make sure a counselor and a valid start date have been selected
                if (counselorSelect.val() != "" && startDateTimePicker.val() && startDateTimePicker.valid() ) {

                    // Show the selected start date at the top of the schedule
                    selectedDateLabel.html(
                        new Date(startDateTimePicker.val()).toLocaleDateString(
                            "en-US",
                            {
                                weekday: 'long',
                                month: 'long',
                                day: 'numeric',
                                year: 'numeric'
                            }
                        )
                    );

                    // Only reload the schedule if specified by the caller of this function
                    if (reloadSchedule) {

                        scheduleLoadingTemplate.show();
                        scheduleHolder.hide().empty();

                        counselorSchedule.show();

                        $.get(
                            backendUrls.getCounselorDailySchedule,
                            {
                                counselorKey: counselorSelect.val(),
                                // only send counselor calendar email if calendar intgration is turned on
                                counselorEmailAddress: calendarIntegrationEnabled ? counselorCalendarEmails[counselorSelect.val()] : null,
                                startDateTime: _dateToUTC(startDateTimePicker.val()).toISOString()
                            }

                        ).done(function (results) {

                            scheduleLoadingTemplate.hide();
                            scheduleHolder.show();
                            scheduleHolder.html(results);

                            // Scroll schedule to the top before getting position
                            scheduleHolder.scrollTop(0);
                            // Scroll schedule to the first hour of business (need to adjust by 60 due to position().top being slightly off)
                            scheduleHolder.scrollTop(scheduleHolder.find(".time-slot").not("._outside-of-business").first().position().top - 60);

                            // Set text below schedule
                            var showOutlookText = counselorCalendarEmails[counselorSelect.val()] != null && calendarIntegrationEnabled;

                            outlookApptsHelpText.toggle(showOutlookText);
                            pgApptsHelpText.toggle(!showOutlookText);

                        }).fail(function () {

                            scheduleLoadingTemplate.hide();
                            scheduleHolder.show();
                            scheduleHolder.html(clientTemplates.render(scheduleErrorTemplateKey));

                            outlookApptsHelpText.hide();
                            pgApptsHelpText.hide();
                        });
                    }

                    // If the selected counselor has a calendar account, get rooms and resources available for the selected time
                    if (calendarIntegrationEnabled && counselorCalendarEmails[counselorSelect.val()]) {

                        roomsAndResourcesSpinners.show();

                        appointmentCheckbox.prop("disabled", false).change();

                        appointmentSection.show();

                        $.get(
                            backendUrls.getAvailableRoomsAndResources,
                            {
                                startDateTime: _dateToUTC(startDateTimePicker.val()).toISOString(),
                                duration: durationPicker.val()
                            }

                        ).done(function (results) {

                            selectHelper.getHelper(roomSelect)
                                .replaceOptions(results.rooms, { withBlank: true, maintainSelection: true })
                                .disableOptions(results.roomsDisableList);

                            selectHelper.getHelper(resourcesSelect)
                                .replaceOptions(results.resources, { withBlank: false, maintainSelection: true })
                                .disableOptions(results.resourcesDisableList);

                        }).always(function () {
                            roomsAndResourcesSpinners.hide();
                        });
                    }
                    else {

                        // If the selected counselor does not have a calendar account clear, disable and hide this section
                        appointmentCheckbox.prop("disabled", true);
                        roomSelect.val(null);
                        selectHelper.getHelper(roomSelect).setDisabled(true);
                        resourcesSelect.val(null);
                        selectHelper.getHelper(resourcesSelect).setDisabled(true);
                        additionalAttendess.val(null).prop("disabled", true);
                        privateCheckbox.setChecked(false).prop("disabled", true);

                        appointmentSection.hide();
                    }
                }
                else {
                    // If a counselor and a start date have not been selected, hide the schedule
                    counselorSchedule.hide();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);